import {Workbox} from "workbox-window";
import {getMeta} from "./utils";
import rootLogger from "./log";

const log = rootLogger.getLogger('window-workbox');

if (!('serviceWorker' in navigator)) {
    throw new TypeError('Service worker is required');
}
log.info('WB: register service worker');

export const wb = new Workbox(getMeta('service-worker'));

wb.addEventListener('waiting', () => {
    log.debug('WB waits (should not happen), trying to skip...');
    wb.messageSkipWaiting();
});

export const registration = await wb.register({ immediate: true });

if (navigator.serviceWorker.controller === null) {
    log.warn('no controller');
}
const sw = wb.getSW();
log.debug(`WB: registered service worker with state ${(await sw).state}`);

sw.then(sw => {
    sw.addEventListener('statechange', () => {log.debug(`WB: state changed: ${sw.state}`)});
});

export const onServiceWorkerActivated = async (cb) => {
    const mySw = await wb.getSW();
    // it is not yet active, run the callback, when that happens
    const listener = () => {
        if (mySw.state === 'activated') {
            mySw.removeEventListener('statechange', listener);
            cb();
        }
    };
    mySw.addEventListener('statechange', listener);
    listener();
};
